import React, { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Link as MUILink,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

const NavBar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();

  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleDrawer = () => setMobileOpen((prev) => !prev);

  const navLinks = [
    { label: 'Get Started', to: '/get-started', onClick: null },
    { label: 'Login', to: '/login', onClick: () => {
        // Clear any existing auth state so Login always starts fresh,
        // even if a student with incomplete profile is currently logged in.
        try {
          localStorage.removeItem('token');
          sessionStorage.removeItem('token');
          localStorage.removeItem('user');
          sessionStorage.removeItem('user');
        } catch (_) {}
        navigate('/login', { replace: true });
      } 
    },
    { label: 'Support', to: '/support', onClick: null },
  ];

  const linkList = (
    <Box sx={{ width: 240 }} role="presentation" onClick={toggleDrawer}>
      <List>
        {navLinks.map(({ label, to, onClick }) => (
          <ListItem
            button
            component={RouterLink}
            to={to}
            key={label}
            onClick={onClick || undefined}
          >
            <ListItemText primary={label} />
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      <AppBar
        position="static"
        color="transparent"
        elevation={0}
        sx={{ backgroundColor: 'rgba(255,255,255,0.8)', backdropFilter: 'blur(10px)' }}
      >
        <Box maxWidth="lg" sx={{ width: '100%', mx: 'auto', px: 3 }}>
          <Toolbar disableGutters>
            <Typography
              variant="h6"
              component={RouterLink}
              to="/"
              sx={{
                flexGrow: 1,
                fontWeight: 700,
                color: 'primary.main',
                textDecoration: 'none',
                '&:hover': { color: 'primary.dark' },
              }}
            >
              ThinkStyne
            </Typography>

            {isMobile ? (
              <IconButton edge="end" color="inherit" aria-label="menu" onClick={toggleDrawer}>
                <MenuIcon />
              </IconButton>
            ) : (
              <Box sx={{ display: 'flex', gap: 3, alignItems: 'center' }}>
                {navLinks.map(({ label, to, onClick }) => (
                  <MUILink
                    key={label}
                    component={RouterLink}
                    to={to}
                    onClick={onClick || undefined}
                    underline="hover"
                    sx={{
                      color: label === 'Get Started' ? 'primary.main' : 'text.primary',
                      fontWeight: label === 'Get Started' ? 700 : 500,
                    }}
                  >
                    {label}
                  </MUILink>
                ))}
              </Box>
            )}
          </Toolbar>
        </Box>
      </AppBar>

      <Drawer anchor="right" open={mobileOpen} onClose={toggleDrawer} ModalProps={{ keepMounted: true }}>
        {linkList}
      </Drawer>
    </>
  );
};

export default NavBar;
